import * as types from '@/store/mutations'
import api from '@/services/dealer'

const state = {
    filters:{

    },
    tags:[],
    dealers:[]
}

const getters = {
  dealers: (state) => state.dealers,
  dealerTags: (state) => state.tags
}

const actions = {
  getAllDealers({ commit }){
      return new Promise((resolve,reject)=>{
          api.dealers().then(r => {
            //console.log(r)
            commit(types.SET_DEALERS, r)
            resolve(r)
          }).catch((e)=>{
            reject(e)
          })
      })


  },
  getDealer(context,id){
    return new Promise((resolve,reject)=>{
      api.dealer(id).then(r => {
        //console.log('dealer.js getDealer resolved for ' + id,r);
        resolve(r)
      }).catch((e)=>{
        reject(e)
      })
    })

  },
  addDealerDiscountCode(context, payload){
      return new Promise((resolve,reject)=>{
          api.createDiscountCode(payload).then((r)=>{
              resolve(r)
          }).catch((e)=>{
              reject(e)
          })
      })
  },
  loadPrimaryCodeForDealer(context, payload){
    return new Promise((resolve,reject)=>{
      api.loadPrimaryCodeForDealer(payload).then((r)=>{
        resolve(r)
      }).catch((e)=>{
        reject(e)
      })
    })
  },
  loadHostessCodesForDealer(context, payload){
    return new Promise((resolve,reject)=>{
      api.loadHostessCodesForDealer(payload).then((r)=>{
        resolve(r)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

  addDealerTag(context, payload){
   return new Promise((resolve,reject)=>{
       api.addTag({"tagName":payload}).then((r)=>{
           resolve(r)
       }).catch((e)=>{
           reject(e)
       })
   })
  },
  addTagToDealer(context, payload){
      return new Promise((resolve,reject)=>{
          api.addTagToDealer(payload.id, payload.hcid).then((r)=>{
              resolve(r)
          }).catch((e)=>{
              reject(e)
          })
      })

  },
  removeTagFromDealer(context, payload) {
      return new Promise((resolve,reject)=>{
          api.removeTagFromDealer(payload.id, payload.hcid).then((r)=>{
              resolve(r)
          }).catch((e)=>{
              reject(e)
          })
      })
  },
  getAllTags({ commit }){
    return new Promise((resolve,reject)=>{
      api.tags().then(r => {
        //console.log(r)
        commit(types.SET_AVAILABLE_TAGS, r)
        resolve(r)
      }).catch((e)=>{
        reject(e)
      })
    })
  },

}

const mutations = {
  [types.SET_DEALERS](state,payload){
    state.dealers = payload
    //console.log(payload)
  },
  [types.SET_AVAILABLE_TAGS](state,payload){
    state.tags = payload
    //console.log(payload)
  }
  
}


export default {
    state,
    getters,
    actions,
    mutations
}
